// removed by extract-text-webpack-plugin
module.exports = {"form":"_1NJQz4K-S vUrsJl1Yt","select":"_2W7bmMk2O JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U _2WNDOuoxI"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/setupform-form.css
 ** module id = 681
 ** module chunks = 0
 **/